import $ from 'jquery'

export default {
    name: 'edit-dmp',
    components: {},
    props: ["editing_type_dmp"],
    data() {
        return {
            value: [],
            is_visible: [],
            disponibilite: [],
            dmp_field: '',
            sv_loading: false,
            btn_field_disable: false,

            field_is_loading: true,
            field_is_empty: false,

            selected_fields: [],

            to_fill_is_empty: false,
            to_fill_loading: true,

            filtered_content: [{}],

            field_checked: [],

            data_to_be_deleted: [],
            del_loading: false,
            is_confirm: false,
            del_btn_disable: false,

            btn_disable: false,
            save_loading: false,

            r_champ: '',
        }
    },

    watch: {
        dmp_by_type() {
            this.refreshDmp()
        }
    },

    computed: {
        consultationEnCours() {
            return this.$store.getters["consultationPatientEnCours"]
        },

        all_champ_dmp() {
            return this.$store.getters['all_champ_dmp']
        },

        dmp_by_type() {
            return this.$store.getters['dmp_by_type']
        },

        dmp_contents() {
            return this.$store.getters['dmp_contents']
        }
    },

    mounted() {
        // Liste les types de dossier medical ajouté
        this.refreshConsultationTypeDmp()

        this.refreshChampDmp()

        this.$store.dispatch('getDmpContents')
    },

    methods: {
        onDisponibilite(champ_id, index) {
            
            if (this.disponibilite[champ_id] == 0) {
                this.is_visible[champ_id] = true
            } else {
                this.is_visible[champ_id] = false
            }
            
            // Decommenter pour cache le champ à remplir si NON choisi
            this.dmp_by_type[index].est_indisponible = parseInt(this.disponibilite[champ_id])
        },

        goToDmp() {
            let dmp = ''
            this.$emit('changeView', { type_dmp: dmp, is_edit: false })
        },

        refreshDmp() {
            this.to_fill_loading = true
            if (this.dmp_by_type.length > 0) {
                this.to_fill_is_empty = false
            } else {
                this.to_fill_is_empty = true
            }
            this.to_fill_loading = false
        },

        async refreshConsultationTypeDmp() {
            this.to_fill_loading = true
            let dmp_param = {
                patient_id: this.$route.params.id,
                type_dmp: this.getTypeDmpEditing()
            }
            await this.$store.dispatch('getDmpByType', dmp_param).then(async () => {
                if (this.dmp_by_type.length > 0) {
                    this.to_fill_is_empty = false

                    await this.dmp_by_type.forEach((el) => {

                        this.disponibilite[el.champ_id] = el.est_indisponible
                        this.is_visible[el.champ_id] = !el.est_indisponible
                    })
                } else {
                    this.to_fill_is_empty = true
                }
                this.to_fill_loading = false
            })
        },

        refreshChampDmp() {
            let type_dmp = this.getTypeDmpEditing()
            this.$store.dispatch('getAllChampDmp', type_dmp).then(() => {
                if (this.all_champ_dmp.length > 0) {
                    this.field_is_empty = false
                } else {
                    this.field_is_empty = true
                }
                this.field_is_loading = false
            })
        },

        filterDMPContent(index) {
            this.filtered_content[index] = [];
            if (this.value[index].length > 0) {
                this.dmp_contents.forEach(
                    element => {
                        if (element.contenu_dmp.toLowerCase().includes(this.value[index].toLowerCase())) {
                            this.filtered_content[index].push(element)
                        }
                    }
                )
            }
        },

        /**
         * Ajoute un nouveau motif
         * @param {} index 
         */
        addNewContent(index) {
            let j = 0

            let len = 0
            if (this.dmp_by_type.contenu) {
                len = this.dmp_by_type[index].contenu.length
            }

            let tmp_motif = {
                contenu_id: 0,
                contenu_dmp: this.value[index]
            }

            // Verifier si motif déjà choisi
            if (len > 0) {
                for (let i = 0; i < len; i++) {
                    if (this.value[index] == this.dmp_by_type[index].contenu[i].contenu_dmp) {
                        j++;
                    }
                }
            }
            if (j == 0) {
                this.dmp_by_type[index].contenu.push(tmp_motif);

                this.value[index] = ''
                this.filtered_content = []
            }
        },

        addExistingContent(data, index) {
            let j = 0
            let len = 0
            if (this.dmp_by_type.contenu) {
                len = this.dmp_by_type[index].contenu.length
            }

            // Verifier si motif déjà choisi
            if (len > 0) {
                for (let i = 0; i < len; i++) {
                    if (data.contenu_dmp == this.dmp_by_type[index].contenu[i].contenu_dmp) {
                        j++;
                    }
                }
            }
            if (j == 0) {
                this.dmp_by_type[index].contenu.push(data);

                this.value[index] = ''
                this.filtered_content = []
            }
            this.filtered_content = []
        },

        async submitDMPField() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

            this.sv_loading = true
            this.btn_field_disable = true

            let field_data = {
                type_dmp: this.getTypeDmpEditing(),
                champ_dmp: this.dmp_field
            }

            this.$store.dispatch('saveChampDMP', field_data).then((response) => {
                if (response > 0) {
                    this.successMsg('Champ créé avec succès')
                    this.refreshChampDmp()

                    this.$refs.observer.reset()
                    this.dmp_field = ''
                    $('.modal').modal('hide')
                }
                this.sv_loading = false
                this.btn_field_disable = false
            })
        },

        successMsg: function (message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        getTypeDmpEditing() {
            let type_dmp = ''

            if (this.editing_type_dmp == 'Antécédents généraux') {
                type_dmp = 'antecedent_generaux'
            } else if (this.editing_type_dmp == 'Antécédents professionnels') {
                type_dmp = 'antecedent_pro'
            } else if (this.editing_type_dmp == 'Antécédents héréditaires et familiaux') {
                type_dmp = 'antecedent_hereditaux'
            } else if (this.editing_type_dmp == 'Vaccinations') {
                type_dmp = 'vaccination'
            }


            return type_dmp
        },

        setToFill(field_to_fill) {
            let j = 0
            let len = this.dmp_by_type.length

            // Verifier si champ déjà choisi
            if (len > 0) {
                for (let i = 0; i < this.dmp_by_type.length; i++) {
                    if (field_to_fill.champ == this.dmp_by_type[i].champ) {

                        j++;
                        let confirm = document.getElementById('ant' + field_to_fill.champ_id);
                        if (confirm.checked == false) {
                            if (this.dmp_by_type[i].contenu.length > 0) {
                                this.r_champ = field_to_fill.champ
                                document.getElementById("ant" + this.dmp_by_type[i]['champ_id']).checked = true;

                                $('.m-warning').modal('show')
                            } else {
                                this.removeField(i)
                            }

                        }
                    }
                }
            }

            if (j == 0) {
                this.dmp_by_type.push(field_to_fill)
                this.disponibilite[field_to_fill.champ_id] = 0
                this.is_visible[field_to_fill.champ_id] = true

                // this.dmp_by_type.push()
                // this.dmp_by_type[index].est_indisponible.push(parseInt(this.disponibilite[field_to_fill.champ_id]))
            }
            
        },

        removeField(index) {
            this.dmp_by_type.splice(index, 1)
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        remove(data, champ_id) {
            this.data_to_be_deleted = {
                id: data.contenu_id,
                contenu_dmp: data.contenu_dmp,
                patient_id: this.$route.params.id,
                champ_id: champ_id,
                type_dmp: this.getTypeDmpEditing()
            }
        },

        /**
         * Retirer Diagnostic/Hypothèse diagnostique
         */
        supprimer() {
            this.del_loading = true;
            this.del_btn_disable = true

            let confirm = document.getElementById('cfrm-del-ant');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
                this.del_btn_disable = false
            }

            if (err == 0) {
                this.$store.dispatch('removeConsultationDmpContent', this.data_to_be_deleted).then((response) => {
                    if (response > 0) {
                        this.refreshConsultationTypeDmp()
                        this.successMsg('Suppression effectuée avec succès')
                    }

                    $('.modal').modal('hide')
                    this.del_loading = false;
                    this.is_confirm = false
                    this.del_btn_disable = false
                })
            }
        },

        saveTypeDMP() {
            this.btn_disable = true
            this.save_loading = true

            let data = {
                patient_id: this.$route.params.id,
                type_dmp: this.getTypeDmpEditing(),
                dmp: this.dmp_by_type
            }

            this.$store.dispatch('saveConsultationDmp', data).then((response) => {
                if (response > 0) {
                    this.successMsg('Enregistrement effectué avec succès')
                    this.refreshConsultationTypeDmp()
                }

                this.btn_disable = false
                this.save_loading = false
            })
        },
    }
}


